import { render, staticRenderFns } from "./olympics_table.vue?vue&type=template&id=c75e5166&"
import script from "./olympics_table.vue?vue&type=script&lang=js&"
export * from "./olympics_table.vue?vue&type=script&lang=js&"
import style0 from "./olympics_table.vue?vue&type=style&index=0&id=c75e5166&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports